export const FIELD_DESTINATION = 'destination';
export const FIELD_AIRPORTS = 'airports';
export const FIELD_TRAVELLERS = 'travellers';
export const FIELD_TRAVELLERS_MULTIROOM = 'travellersMultiroom';
export const FIELD_TRAVEL_PERIOD = 'travelPeriod';
export const FIELD_TRAVEL_TYPE = 'travelType';